import { axios } from '../../services/axios';

export default async function deleteSRTTrunk(trunkId) {
    const result = await axios.delete(`/trunk/${trunkId}`);
    return result;
}
